

































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  RoleDTO,
} from '@/api';

interface IForm {
  firstName?: string;
  surname?: string;
  phoneNumber?: string;
  email?: string;
  roleIds?: Array<string>;
  password?: string;
}

@Component({
  name: 'user-form',
})
export default class UserForm extends Vue {
  @Prop({ type: Number }) index?: number;

  @Prop({ type: Object, required: true }) form!: IForm;

  @Prop({ type: Array, default: () => [] }) rolesList!: RoleDTO[];

  @Prop({ type: Boolean, default: false }) withPassword!: boolean;

  get firstName() {
    return this.form.firstName;
  }

  set firstName(value: string | undefined) {
    this.updateForm<'firstName'>('firstName', value);
  }

  get surname() {
    return this.form.surname;
  }

  set surname(value: string | undefined) {
    this.updateForm<'surname'>('surname', value);
  }

  get phoneNumber() {
    return this.form.phoneNumber;
  }

  set phoneNumber(value: string | undefined) {
    this.updateForm<'phoneNumber'>('phoneNumber', value);
  }

  get email() {
    return this.form.email;
  }

  set email(value: string | undefined) {
    this.updateForm<'email'>('email', value);
  }

  get password() {
    return this.form.password;
  }

  set password(value: string | undefined) {
    this.updateForm<'password'>('password', value);
  }

  get roleIds() {
    return this.form.roleIds || [''];
  }

  set roleIds(value: Array<string>) {
    this.updateForm<'roleIds'>('roleIds', value);
  }

  selectRole(value: string, index: number) {
    this.roleIds = [...this.roleIds.splice(0, index), value, ...this.roleIds.splice(index + 1)];
  }

  createRolesField() {
    if (this.roleIds) {
      this.roleIds = [...this.roleIds, ''];
    }
  }

  deleteRolesField(index: number) {
    if (this.roleIds) {
      this.roleIds = [...this.roleIds.splice(0, index), ...this.roleIds.splice(index + 1)];
    }
  }

  updateForm<K extends keyof IForm>(propertyName: K, value: IForm[K]) {
    if (this.index != null) {
      this.$emit('field-change', propertyName, value, this.index);
    } else {
      this.$emit('field-change', propertyName, value);
    }
  }
}
